var React = require('react');
var PropTypes = React.PropTypes;
import ReactTooltip from 'react-tooltip';
import Helpers from '../../utils/helpers';
import '../../css/components/Tasks/collectionInfoRow.css';

var CollectionInfoRow = React.createClass({
  getInitialState: function() {
    return {
      data: this.props.data,
      conceptsMap: this.props.conceptsMap
    };
  },

  componentWillReceiveProps: function(nextProps) {
    this.setState({
      data: nextProps.data || this.state.data,
      conceptsMap: nextProps.conceptsMap || this.state.conceptsMap
    })
  },

  render: function() {
    const {
      conceptsMap,
      data
    } = this.state;
    return (
      <div className="collection-info-row">
        <div className="dp-table wrapper">
          <div className="dp-table-cell cell text-left" data-tip data-for="subject">
            <span className="txt-primary">
              Subject:
              <span className="txt-secondary padding-left-10">
                {conceptsMap && data && data.concepts ? Helpers.getSubject(conceptsMap, data.concepts[0]).title : '---'}
              </span>
              <ReactTooltip id="subject" effect="solid">
                {conceptsMap && data && data.concepts ? Helpers.getSubject(conceptsMap, data.concepts[0]).title : '---'}
              </ReactTooltip>
            </span>
          </div>
          <div className="dp-table-cell cell text-center" data-tip data-for="concept">
            <span className="txt-primary">
              Concept:
              <span className="txt-secondary padding-left-10">
                {conceptsMap && data && data.concepts ? conceptsMap[data.concepts[0]].title : '---'}
              </span>
              <ReactTooltip id="concept" effect="solid">
                {conceptsMap && data && data.concepts ? conceptsMap[data.concepts[0]].title : '---'}
              </ReactTooltip>
            </span>
          </div>
          <div className="dp-table-cell cell text-right" data-tip data-for="creator">
            <span className="txt-primary">
              Creator:
              <span className="txt-secondary padding-left-10">
                {data.creatorName || '---'}
              </span>
              <ReactTooltip id="creator" effect="solid">
                {data.creatorName || '---'}
              </ReactTooltip>
            </span>
          </div>
        </div>
      </div>
    );
  }

});

module.exports = CollectionInfoRow;



/** WEBPACK FOOTER **
 ** ./src/components/Tasks/CollectionInfoRow.js
 **/